/*
 Login component
 url match: / or /login
 Displays email id and password field
 with Login button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import Images from '../../Theme/Images';
import { withStyles } from '@material-ui/core/styles';
import { settingsStyles } from '../../Styles/userStyles';
import { ReactSVG } from 'react-svg';
import Typography from '@material-ui/core/Typography';
import Loader from 'react-loader-spinner'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Header from '../../Common/Header'
import ChangePasswordDialog from './ChangePasswordDialog'
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Scrollbars } from 'react-custom-scrollbars';
import Tooltip from '@material-ui/core/Tooltip';

@inject('commonStore', 'userStore', 'adminStore')
@observer
class UserSettings extends React.Component {
    state = {
        validationErrors: {},
        updatePic: false,
        img: ''
    }

    constructor() {
        super()
        this.inputOpenFileRef = React.createRef()
    }

    openFileModal = () => {
        this.inputOpenFileRef.current.click();
    }

    onChangeFile = (event, type) => {
        event.stopPropagation();
        event.preventDefault();
        if (!event.target.files.length)
            return;
        var img = event.target.files[0];
        this.setState({ updatePic: true, img: img })
        var reader = new FileReader();
        reader.onload = (e) => {
            this.props.userStore.setProfilePic(e.target.result)
        }
        reader.readAsDataURL(img);
    }

    componentDidMount() {
        this.props.commonStore.setActiveTab('settings');
        this.props.userStore.getUserDetails()
    }

    changePassword = () => {
        this.props.userStore.openChangePasswordDialog(true);
    }

    validateFields() {
        const { validationErrors } = this.state;
        const { userDetails } = this.props.userStore
        const { adminStore } = this.props;
        var mob = /^[1-9]{1}[0-9]{9}$/;
        let valid = true;
        if (!this.props.userStore.validateEmail(userDetails.email)) {
            validationErrors['email'] = "Please enter a valid email address";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['email']
        if (!userDetails.userFullName || userDetails.userFullName.length < 3 || userDetails.userFullName.length > 40 || !userDetails.userFullName.replace(/\s/g, '').length) {
            validationErrors['userFullName'] = "Name must contain a minimum of 3 and maximum of 40 characters ";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['userFullName']
        if (!userDetails.department || userDetails.department.length < 3 || userDetails.department.length > 40 || !userDetails.department.replace(/\s/g, '').length) {
            validationErrors['department'] = "Department must contain a minimum of 3 characters ";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['department']
        if (userDetails.mobileNumber && userDetails.mobileNumber.replace(/\s/g, '').length) {
            if (!userDetails.mobileNumber || !mob.test(userDetails.mobileNumber)) {
                validationErrors['mobileNumber'] = "Please enter a valid 10-digit mobile number!";
                this.setState({ validationErrors });
                valid = false;
            }
            else
                delete validationErrors['mobileNumber']
        }
        else
            delete validationErrors['mobileNumber']
        if (!userDetails.domain || userDetails.domain.length < 3 || userDetails.domain.length > 40 || !userDetails.domain.replace(/\s/g, '').length) {
            validationErrors['domain'] = "Domain must contain a minimum of 3 characters ";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['domain']

        if (valid) {
            this.setState({
                validationErrors: {}
            });
        }
        return valid;
    }

    saveSettings = (e) => {
        e.preventDefault();
        let valid = false;
        valid = this.validateFields()
        if (valid) {
            if (this.state.updatePic)
                this.props.userStore.updateUserSettings(this.state.img);
            else
                this.props.userStore.updateUserSettings();
        }

        else
            return

    }

    resendEmail = (user) => {
        this.props.adminStore.resendUpdateVerificationEmail(user)
    }

    cancel = () => {
        this.props.history.push('/dashboard/drafts');
    }


    render() {
        const { classes, theme, userStore } = this.props;
        const { inProgress, userDetails, changePasswordDialog, user, updateProgress } = this.props.userStore;
        const { validationErrors } = this.state;

        if (inProgress && !changePasswordDialog)
            return (
                <div style={{ height: '100%' }}>
                    <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                </div>
            )
        return (
            <Scrollbars>
                <div style={{ height: '100%' }}>
                    <div className={classes.outerContainer}>
                        <div><Typography className={classes.heading}>Settings</Typography></div>
                        <Header></Header>
                    </div>
                    <div style={{ backgroundColor: theme.palette.dark }}>
                        <div className={classes.innerContainer}>
                            <div className={classes.profile}>
                                {
                                    userDetails.profilePic ? <img className={classes.profilePic} src={userDetails.profilePic}></img> : <ReactSVG src={Images.profile} />
                                }
                                <div className={classes.editSvg}><ReactSVG onClick={(e) => this.openFileModal()} src={Images.edit} /></div>
                            </div>
                            <input
                                accept="image/*"
                                type="file"
                                style={{ display: "none" }}
                                ref={this.inputOpenFileRef}
                                onChange={(e) => this.onChangeFile(e, false)}
                            />

                            <div className={classes.details}>
                                {user.userFullName}
                                <Typography style={{ color: theme.palette.steelGray2, fontSize: '13px' }} display="block" gutterBottom>{user.email}</Typography>
                            </div>
                            <form noValidate autoComplete="off" className={classes.formStyle}>
                                <TextField color="primary" style={{ paddingTop: 0, marginTop: 0 }} id="name"
                                    label='Full Name'
                                    margin="normal"
                                    variant="filled"
                                    InputProps={{
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={userDetails.userFullName}
                                    onChange={(event) => userStore.handleFormChange("userFullName", event.target.value)}
                                />
                                {validationErrors.userFullName && <FormHelperText error={true} style={{ display: 'flex' }} id="email-error">
                                    <ReactSVG
                                        beforeInjection={svg => {
                                            svg.classList.add(classes.svg)
                                        }}
                                        src={Images.error} />
                                    {validationErrors.userFullName}</FormHelperText>}
                                <TextField color="primary" style={{ paddingTop: 0, marginTop: 0 }} id="email"
                                    label='Email'
                                    margin="normal"
                                    variant="filled"
                                    InputProps={{
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        endAdornment: <InputAdornment position="end">
                                            {<ReactSVG src={Images.error} />}
                                        </InputAdornment>
                                    }}
                                    value={userDetails.newEmail ? userDetails.newEmail : userDetails.email}
                                    onChange={(event) => userStore.handleFormChange("email", event.target.value)}
                                />
                                {validationErrors.email && <FormHelperText error={true} style={{ display: 'flex' }} id="email-error">
                                    <ReactSVG
                                        beforeInjection={svg => {
                                            svg.classList.add(classes.svg)
                                        }}
                                        src={Images.error} />
                                    {validationErrors.email}</FormHelperText>}
                                <div className="rowFlex">
                                    <div style={{ width: '50%', marginRight: '1vw' }}>
                                        <TextField color="primary" style={{ paddingTop: 0, marginTop: 0, marginRight: '1vw' }} id="dept"
                                            label='Department'
                                            margin="normal"
                                            variant="filled"
                                            fullWidth
                                            InputProps={{
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            value={userDetails.department}
                                            onChange={(event) => userStore.handleFormChange("department", event.target.value)}
                                        />
                                        {validationErrors.department && <FormHelperText error={true} style={{ display: 'flex' }} id="dept-error">
                                            <ReactSVG
                                                beforeInjection={svg => {
                                                    svg.classList.add(classes.svg)
                                                }}
                                                src={Images.error} />
                                            {validationErrors.department}</FormHelperText>}
                                    </div>
                                    <div style={{ width: '50%' }}>
                                        <TextField color="primary" style={{ paddingTop: 0, marginTop: 0 }} id="domain"
                                            label='Domain'
                                            margin="normal"
                                            variant="filled"
                                            fullWidth
                                            InputProps={{
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            value={userDetails.domain}
                                            onChange={(event) => userStore.handleFormChange("domain", event.target.value)}

                                        />
                                        {validationErrors.domain && <FormHelperText error={true} style={{ display: 'flex' }} id="domain-error">
                                            <ReactSVG
                                                beforeInjection={svg => {
                                                    svg.classList.add(classes.svg)
                                                }}
                                                src={Images.error} />
                                            {validationErrors.domain}</FormHelperText>}
                                    </div>
                                </div>
                                <TextField color="primary" style={{ paddingTop: 0, marginTop: 0 }} id="mobile"
                                    label='Mobile Number'
                                    margin="normal"
                                    variant="filled"
                                    InputProps={{
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={userDetails.mobileNumber}
                                    onChange={(event) => userStore.handleFormChange("mobileNumber", event.target.value)}
                                /> {validationErrors.mobileNumber && <FormHelperText error={true} style={{ display: 'flex' }} id="dept-error">
                                    <ReactSVG
                                        beforeInjection={svg => {
                                            svg.classList.add(classes.svg)
                                        }}
                                        src={Images.error} />
                                    {validationErrors.mobileNumber}</FormHelperText>}


                            </form>
                            <div className={classes.passwordContainer}>
                                <div className={classes.details}>
                                    Password
                        <Typography style={{ color: theme.palette.steelGray2, fontSize: '13px' }} gutterBottom>Set a unique password to protect your ICR account.</Typography>
                                </div>
                                <div style={{ marginTop: '2vh' }}>
                                    <Button variant="contained" className={classes.button} type="submit" onClick={this.changePassword} fullWidth> Change Password  </Button>
                                </div>
                            </div>
                            {
                                userDetails.newEmail && userDetails.userType === "ADMIN" ?
                                    <FormHelperText error={true} style={{ display: 'flex' }} id="domain-input">
                                        <ReactSVG beforeInjection={svg => { svg.classList.add(classes.svg) }} src={Images.error} />
                       Email Verification Pending. <span className={classes.resendMail} onClick={(e) => this.resendEmail(userDetails)}> Resend mail</span> </FormHelperText>
                                    : null
                            }
                            <div className={classes.saveContainer}>
                                <Button variant="contained" className={classes.button} onClick={this.cancel} > Cancel  </Button>
                                {
                                    updateProgress
                                        ?
                                        <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }}><Loader height={30} width={30} color={this.props.theme.palette.white} /></Button> :
                                        <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }} type="submit" onClick={this.saveSettings} > Save  </Button>
                                }
                            </div>
                        </div>
                    </div>
                    <ChangePasswordDialog></ChangePasswordDialog>
                </div>
            </Scrollbars>
        );
    }
}

export default withStyles(settingsStyles, { withTheme: true })(withRouter(UserSettings));
